import { render } from "./StatisticsDashboard.vue?vue&type=template&id=1092f04c"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=js"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__